import { toast } from 'react-hot-toast';
import { ICreateInvoiceData } from '../@types';
import { invoiceService } from '../services';
const BASE = `invoices`;

export const createInvoice = async (data: ICreateInvoiceData) => {
  try {
    const res = await invoiceService.post(`/${BASE}`, data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const createReoccurringInvoice = async (data: ICreateInvoiceData) => {
  try {
    const res = await invoiceService.post(`/${BASE}`, data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const getInvoice = async (id: string) => {
  try {
    const res = await invoiceService.get(`/${BASE}/${id}`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};


export const toggleReoccurringInvoice = async ({
  id,
  isReoccurringEndDate,
  reoccurringGroupName,
}: {
  id: string;
  reoccurringGroupName: string;
  isReoccurringEndDate?: string;
}) => {
  try {
    const res = await invoiceService.put(`/invoices/${id}/toggleReoccurring`, {
      reoccurringGroupName,
      isReoccurringEndDate,
    });
    return res.data;
  } catch (e: any) {
    // toast.error(e.response?.data || e.message);
    // throw new Error(e.response?.data || e.message);
  }
};

export const refundInvoice = async ({ id }: { id: string }) => {
  try {
    const res = await invoiceService.patch(`/invoices/${id}/refund`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const cancelInvoice = async ({ id }: { id: string }) => {
  try {
    const res = await invoiceService.patch(`/invoices/${id}/cancel`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};
export const getCustomerInvoices = async ({ customerId }: { customerId: string }) => {
  try {
    const res = await invoiceService.get(`/invoices/customers/${customerId}`);
    return res.data;
  } catch (e: any) {
    const errorMessage = 'An error occurred while fetching customer invoices.';
      toast.error(errorMessage); 
    throw new Error(errorMessage); 
  }
};
export const createDraft = async (data: ICreateInvoiceData) => {
  try {
    const res = await invoiceService.post(`/${BASE}`, data);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    throw new Error(e.response?.data || e.message);
  }
};

export const updateToPending = async ({ id, data }: { id: string; data: { status: string } }) => {
  try {
    const res = await invoiceService.patch(`/invoices/${id}/save`, data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const getPaymentReminder = async (id: string) => {
  try {
    const res = await invoiceService.get(`/${BASE}/${id}/payment-reminder`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const getInvoiceDownload = async (id: string) => {
  try {
    const res = await invoiceService.get(`/${BASE}/${id}/generate-download`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};
